function initRelatedProductsSwiper(swiper) {
  const slidesDesktop = swiper.getAttribute('data-slides-desktop');
  const slidesMobile = swiper.getAttribute('data-slides-mobile');

  // Avoid initializing twice
  if (swiper.classList.contains('swiper-initialized')) return;

  new Swiper(swiper, {
    slidesPerView: slidesMobile,
    spaceBetween: 15,
    loop: true,
    navigation: {
      nextEl: '.slider-button--next',
      prevEl: '.slider-button--prev',
    },
    breakpoints: {
      1024: {
        slidesPerView: parseInt(slidesDesktop, 10) || 4,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
    },
  });
}

// Keep track of whether we've initialized
let allSwipersInitialized = false;

// Start observing the body for added nodes
const observer = new MutationObserver(function (mutationsList, observerInstance) {
  let initializedAny = false;

  mutationsList.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;

      if (node.matches('[data-swiper-name="related-products"]')) {
        initRelatedProductsSwiper(node);
        initializedAny = true;
      } else {
        const swipers = node.querySelectorAll('[data-swiper-name="related-products"]');
        swipers.forEach((swiper) => {
          initRelatedProductsSwiper(swiper);
          initializedAny = true;
        });
      }
    });
  });

  // If at least one swiper was initialized, check if any uninitialized swipers remain
  if (initializedAny) {
    const uninitialized = document.querySelectorAll('[data-swiper-name="related-products"]:not(.swiper-initialized)');
    if (uninitialized.length === 0) {
      observerInstance.disconnect(); // Stop observing
      allSwipersInitialized = true;
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// Initial run on existing nodes
document.querySelectorAll('[data-swiper-name="related-products"]').forEach(initRelatedProductsSwiper);
